import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Tour } from 'src/app/tour-planning/shared/entities/tour';

@Component({
  selector: 'nx-tour-details-overlay',
  templateUrl: './tour-details-overlay.component.html',
  styleUrls: ['./tour-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TourDetailsOverlayComponent {
  @Input() tourDetails: Tour | null = null;
  @Input() isLoading: boolean = false;
  
  @ViewChild('tourOverlayPanel', { static: false }) overlayPanel?: OverlayPanel;

  show(event: Event): void {
    this.overlayPanel?.show(event);
  }

  hide(): void {
    this.overlayPanel?.hide();
  }
}
